export default __webpack_public_path__ + "static/media/pen-black.fb51bf83.svg";